import React from 'react';

function VimeoVideoEmbed() {
    return (
        <div className="video-responsive">
            <iframe 
                title='vimeo video'
                src={`https://player.vimeo.com/video/855785568?color=BCD400&title=0&byline=0&portrait=0`}
                width="640" 
                height="360" 
                frameborder="0" 
                allow="autoplay; fullscreen" 
                allowfullscreen>
            </iframe>
        </div>
    );
}

export default VimeoVideoEmbed;
